
<template>
  <!--新增物流公司-->
  <div>
    <x-addEdit
      ref="addEdit"
      :formList="formList"
      :formKey="formKey"
      :addParam="addParam"
      :editParam="editParam"
      :detailParam="detailParam"
    >
    </x-addEdit>
  </div>
</template>

<script>
export default {
  name: 'addLogistics',
  data () {
    return {
      formList: [
        {
          label: '公司名称',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入公司名称',
          props: ['name', {
            rules: [
              {required: true, message: '请输入公司名称'},
              {max: 20, message: '公司名称最多20位'}
            ]
          }]
        },
        {
          label: '公司类型',
          inputType: 'select',
          options: [
            { value: 1, label: '快递公司' },
            { value: 2, label: '同城配送' }
          ],
          handle: '',
          placeholder: '请选择公司类型',
          props: ['type', {
            rules: [{required: true, message: '请选择公司类型'}]
          }]
        },
        {
          label: '品牌LOGO',
          inputType: 'upload',
          fileList: [],
          uploadParam: {
            url: '/common/upload',
            iconUrl: 'logoUrl', // 详情返回图片的链接
            iconName: '', // 详情返回文件的名

            // action: this.$store.state.uploadUrlJava,
            accept: this.$store.state.imgAccept,
            listType: 'picture',
            uploadType: 4
          },
          props: ['logo', {
            // rules: [{required: true, message: '请上传品牌LOGO'}]
          }]
        },
        {
          label: '物流公司编码',
          inputType: 'input',
          placeholder: '请输入物流公司编码',
          props: ['code', {
            rules: []
          }]
        },
        {
          label: '排序',
          inputType: 'input',
          placeholder: '请输入排序',
          props: ['sort', {
            rules: [
              { pattern: /^\d*$/, message: '请输入数字' },
              { max: 4, message: '排序最多4位' }
            ]
          }]
        }
      ],
      formKey: {
        name: undefined,
        type: undefined,
        logo: undefined,
        code: undefined,
        sort: undefined
      },
      addParam: {
        url: '/pm/logisticsCompany',
        reqHandle: '', // addParam、editParaM都会执行 reqHandle方法
        resHandle: '' // this.addResHandle
      },
      editParam: {
        url: '/pm/logisticsCompany/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/pm/logisticsCompany/',
        resHandle: '' // this.detailResHandle
      }
    };
  },
  created () {
  },
  methods: {
    detailResHandle (res) {
      return res;
    },
    reqHandle (param) {
      return param;
    },
    addResHandle (res) {
      return res;
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
